import { render } from "./PutStorageDialog.vue?vue&type=template&id=3cb2d479&scoped=true"
import script from "./PutStorageDialog.vue?vue&type=script&lang=js"
export * from "./PutStorageDialog.vue?vue&type=script&lang=js"

import "./PutStorageDialog.vue?vue&type=style&index=0&id=3cb2d479&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb2d479"]])

export default __exports__